import { eCalendarEventTypes } from '../../../../../../pages/Agenda/components/Calendar/Calendar.enums';

export function parseAgendaEventType(eventType: string): string {
  switch (eventType) {
    case eCalendarEventTypes.MEETING:
      return 'Reunión';
    case eCalendarEventTypes.CALL:
      return 'Llamada';
    case eCalendarEventTypes.TASK:
      return 'Tarea';
    default:
      return 'Evento';
  }
}
